import { Tab } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { addons } from "./pricingData";

const hiddenAddons = ["CFO Advisory", "ASIC Compliance"];
const visibleAddons = addons.filter((a) => !hiddenAddons.includes(a.name));

export default function PricingAddons() {
  return (
    <section className="py-[100px] px-6 lg:px-10 bg-cream">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-12 fade-in">
          <h2 className="font-inter text-[24px] sm:text-[32px] lg:text-[38px] font-black tracking-[-1.5px] leading-[1.15] mb-4">
            Add-On Services
          </h2>
          <p className="font-inter text-base text-gray-cool-500 leading-[1.7] max-w-[600px] mx-auto">
            Extend your plan with specialised services. Add or remove anytime —
            billed separately from your base plan.
          </p>
        </div>

        <div className="fade-in">
          <Tab.Group>
            <Tab.List className="flex flex-wrap justify-center gap-2 mb-10">
              {visibleAddons.map((addon) => (
                <Tab
                  key={addon.name}
                  className={({ selected }) =>
                    `px-5 py-2.5 rounded-full text-[14px] font-semibold transition-all duration-300 outline-none ${
                      selected
                        ? "bg-blue-primary-500 text-white shadow-[0_4px_12px_rgba(0,116,230,0.3)]"
                        : "bg-white text-gray-cool-700 border border-gray-cool-200 hover:border-blue-primary-500/30 hover:text-blue-primary-500"
                    }`
                  }
                >
                  {addon.name}
                </Tab>
              ))}
            </Tab.List>

            <Tab.Panels>
              {visibleAddons.map((addon) => (
                <Tab.Panel key={addon.name}>
                  <div className="bg-base-white rounded-[20px] p-8 sm:p-10 border border-gray-cool-200 shadow-[0_4px_16px_rgba(0,0,0,0.04)]">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                      {/* Left: Info */}
                      <div>
                        <h3 className="font-inter text-xl font-extrabold tracking-[-0.5px] text-gray-cool-900 mb-4">
                          {addon.name}
                        </h3>
                        <p className="font-inter text-[14px] text-gray-cool-500 leading-[1.7] mb-6">
                          {addon.description}
                        </p>
                        <a
                          href="/contact"
                          className="inline-flex items-center gap-2 bg-blue-primary-500 hover:bg-[#005bb5] text-white px-6 py-3 rounded-full text-[14px] font-semibold transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(0,116,230,0.3)]"
                        >
                          Learn More
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M17 8l4 4m0 0l-4 4m4-4H3"
                            />
                          </svg>
                        </a>
                      </div>

                      {/* Right: Features */}
                      <div className="space-y-3">
                        <p className="font-inter text-[11px] font-bold uppercase tracking-[1px] text-gray-cool-500 mb-4">
                          What&apos;s included
                        </p>
                        {addon.features.map((feature) => (
                          <div
                            key={feature}
                            className="flex items-center gap-2.5 text-sm text-gray-cool-700"
                          >
                            <CheckCircleIcon className="w-5 h-5 text-blue-primary-500 flex-shrink-0" />
                            <span className="font-inter">{feature}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
    </section>
  );
}
